<h2 class="text-2xl font-semibold text-gray-800 my-4">{{ "changeOwner.title" | translate }}</h2>
<!-- <button type="button" (click)="openPdf()">open pdf</button> -->
<form [formGroup]="rootFormGroup" (ngSubmit)="onSubmit()">
    <app-chip-search
        class="hidden"
        [formGroup]="getChipForm()"
        [isRegistration]="false"
        (isChipReadyForRegistration)="updateChipModificationStatus($event)" />

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5 flex flex-row items-center justify-between">
            <div class="flex flex-row items-center">
                <h3 class="text-base font-medium text-gray-800">
                    {{ "chipRegistration.microchip.sectionTitle" | translate }}
                    @if (chipDetails) {
                        #{{ chipDetails.codeInfo.code }}
                    }
                </h3>
            </div>
            <p class="text-base text-gray-700">{{ "chipRegistration.edModificationInStock" | translate }}: <strong>{{ edInStock }}</strong></p>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-chip-info-form [formGroup]="getChipInfoForm()" [isRegistration]="false" [vets]="veterinariansList" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.owner.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-owner-form [formGroup]="getOwnerForm()" [isOwnerSearchAvailable]="true" (searchForOwner)="handleOwnerSearch()" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.animal.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-animal-form [formGroup]="getAnimalForm()" [isAddressControlVisible]="false" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.animalAddress.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <app-animal-address-form [formGroup]="getAnimalAddressForm()" [isAddressSameAsOwner]="animalAddressSameAsOwner" />
        </div>
    </div>

    <div class="rounded-2xl border border-gray-200 bg-white mb-4">
        <div class="px-6 py-5">
            <h3 class="text-base font-medium text-gray-800">
                {{ "chipRegistration.signature.sectionTitle" | translate }}
            </h3>
        </div>
        <div class="border-t border-gray-200 p-4">
            <div class="flex flex-row items-center mb-4">
                <p>
                    {{ "chipRegistration.signature.changeOwnerSignaturs" | translate }}
                </p>
                <p-button class="ml-4" severity="secondary" [label]="'common.sign' | translate" (click)="isSignatureDialogVisible = true;" />
            </div>
        </div>
    </div>

    <p-button severity="primary" type="submit" [disabled]="!rootFormGroup.valid" [label]="'common.submit' | translate" />
</form>

<app-signature
    [signatures]="['veterinarian', 'owner', 'previousOwner']"
    [visible]="isSignatureDialogVisible"
    (closeModal)="isSignatureDialogVisible = false;"
    (saveSignaturesOutput)="handleSignatureSave($event)" />
<!-- <pre>{{ rootFormGroup.getRawValue() | json }}</pre> -->
